import { capitalCase } from "change-case";

export default function UserRolesCell({ value }: { value: string[] }) {
  return <span>{value.map((role) => capitalCase(role)).join(", ")}</span>;
}
